import type { Theme } from "../tokens";
import { aura } from "./aura";
import { indexTheme } from "./index-theme";
import { coroner } from "./coroner";
import { bond } from "./bond";
import { ledger } from "./ledger";
import { amber } from "./amber";
import { grotesk } from "./grotesk";
import { nocturne } from "./nocturne";
import { beacon } from "./beacon";
import { riso } from "./riso";
import { carbon } from "./carbon";

/**
 * Every theme the client ships.
 *
 * Adding one: write a file beside these, import it, and add it to the array.
 * `themes.test.ts` runs the whole registry through the contract in validate.ts,
 * so a palette that cannot be read fails the build rather than shipping.
 */
export const THEMES: readonly Theme[] = [
  aura,
  indexTheme,
  coroner,
  bond,
  ledger,
  amber,
  grotesk,
  nocturne,
  beacon,
  riso,
  carbon,
] as const;

/** The direction chosen in the art bible on 2026-09-24: direction 11, AURA. */
export const DEFAULT_THEME_ID = "aura";

export function themeById(id: string | null | undefined): Theme {
  const found = THEMES.find((t) => t.id === id);
  if (found) return found;
  const fallback = THEMES.find((t) => t.id === DEFAULT_THEME_ID);
  if (!fallback) throw new Error("the default theme is not registered");
  return fallback;
}
